'use strict';

const Slideshow = require('./slideshow');
const Router = require('./router');
const lang = require('./lang');

module.exports = class {
  constructor() {
    lang.load(window.konfig);
    require('./handlebars-helpers')();
    require('./jquery-helpers')();

    this.location = window.konfig.location;
    this.location.photos = this.location.photos.sort((a, b) => a.order - b.order);

    const slideshow = new Slideshow({
      locationObj: this.location,  // the 'location' name is reserved for variables ;_;, fine for properties though!
      photoHost: window.konfig.photoHost,
      languages: window.konfig.languages,
      fields: window.konfig.fields,
      notification: window.konfig.notification,
      nameIcon: window.konfig.nameIcon,
      SlotTimeBookingIcon: window.konfig.SlotTimeBookingIcon,
    });

    new Router(slideshow);
  }
};
